import { DOCUMENT_BLOCK_TYPES, DOCUMENT_ALIGN } from "./schema";

const contratoParceriaVendas = {
  id: "contrato-parceria-vendas",

  blocks: [
    {
      type: DOCUMENT_BLOCK_TYPES.TITLE,
      content: "CONTRATO DE PARCERIA PARA VENDAS",
      align: DOCUMENT_ALIGN.LEFT,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },
    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "PARTE CAPTANTE(S)" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{CAPTANTES}",
      contentFormat: "html",
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "PARTE INTERMEDIADOR(ES)" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{INTERMEDIADORES}",
      contentFormat: "html",
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "As partes identificadas celebram o presente Contrato de Parceria para Venda de Prazo Indeterminado, que será regido pelas cláusulas e condições a seguir descritas.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    { type: DOCUMENT_BLOCK_TYPES.PARAGRAPH, content: "CLÁUSULAS E CONDIÇÕES" },
    { type: DOCUMENT_BLOCK_TYPES.PARAGRAPH, content: "1) OBJETO" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "1.1) Este contrato tem por OBJETO a parceria para a venda dos produtos descritos abaixo, estabelecida entre as partes, sendo estes:",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "1.1.1) {DESCRICAO_PRODUTO}",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    { type: DOCUMENT_BLOCK_TYPES.PARAGRAPH, content: "2) DA INTERMEDIAÇÃO" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "2.1) A PARTE INTERMEDIADOR compromete-se, ao assinar este instrumento, a representar a parte captante de forma a não distorcer as informações dos produtos oferecidos, seguindo fielmente as diretrizes estabelecidas por esta.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "2.2) Fica estabelecido neste instrumento que a PARTE INTERMEDIADOR fará jus à comissão no percentual de {COMISSAO_INTERMEDIADOR}%, calculada sobre o valor total da venda efetivamente concretizada.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "2.3) As comissões devidas à PARTE INTERMEDIADOR serão pagas pela PARTE CAPTANTE de forma proporcional aos valores efetivamente recebidos dos clientes.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "2.4) O presente instrumento não estabelece qualquer vínculo empregatício entre as partes, inexistindo relação de trabalho de natureza subordinada.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "2.5) O descumprimento de quaisquer cláusulas deste contrato dará à parte prejudicada o direito de rescindi-lo.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "2.6) A parte que, agindo de má-fé, vier a realizar o fechamento de venda em desacordo com as disposições deste instrumento ficará obrigada ao pagamento de multa no valor de {MULTA_CONTRATUAL}.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "2.7) Para resolver quaisquer controvérsias decorrentes deste CONTRATO, as partes elegem o foro da comarca de {FORO}.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    { type: DOCUMENT_BLOCK_TYPES.PARAGRAPH, content: "ENCERRAMENTO" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "POR ESTAREM DE ACORDO,\nassinam a 2 (duas) vias do presente contrato.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{CIDADE_ASSINATURA}, {DATA_ASSINATURA}.",
      align: DOCUMENT_ALIGN.RIGHT,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },
    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "PARTE(S) CAPTANTE(ES)" },
    { type: DOCUMENT_BLOCK_TYPES.PARAGRAPH, content: "{ASSINATURA_CAPTANTES}" },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    {
      type: DOCUMENT_BLOCK_TYPES.TITLE,
      content: "PARTE(S) INTERMEDIADOR(ES)",
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_INTERMEDIADORES}",
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "TESTEMUNHAS" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_TESTEMUNHAS}",
    },
  ],
};

export default contratoParceriaVendas;
